import { DEFAULT_LANG } from '@/const/locale';
import { Locales } from '@/locales/resources';
import { defaultLocale } from '@/i18n';
import { isOnServerSide } from '@/utils_cp/env';
import { normalizeLocaleCandidate, resolveBrowserLocale } from '@/utils/language-utils';

import { GlobalState } from '../initial-state';
import { systemStatus } from './system-status';

const language = (s: GlobalState) => systemStatus(s).language || 'auto';

const currentLanguage = (s: GlobalState) => {
  const locale = language(s);

  if (locale === 'auto') {
    if (isOnServerSide) return normalizeLocaleCandidate(DEFAULT_LANG) ?? defaultLocale;

    return resolveBrowserLocale() as Locales;
  }

  return (normalizeLocaleCandidate(locale) ?? defaultLocale) as Locales;
};

export const globalGeneralSelectors = {
  currentLanguage,
  language,
};
